import { Block } from "@components/block";
import { Button } from "@components/button";
import { Input } from "@components/input";
import { CustomSelect, SelectOption } from "@components/select";
import { Config, Table } from "@components/table";
import { useForm } from "react-hook-form";
import styles from "./users.module.scss";
import { useNavigate } from "react-router-dom";
import { AdminUser, AdminUsersRequest } from "@features/admin/users/api";
import { useAdminUsers } from "@features/admin/users";
import { useEffect, useState } from "react";
import { usePagination } from "@hooks/use-pagination";
import { useUrlFilters } from "@hooks/useUrlFilters";
import { getFilterParamFromQuery } from "@helpers/utilities";
import { EllipsisText } from "@components/ellipsis-text";

export enum UserRole {
  Merchant = "merchant",
  Trader = "trader",
  Teamlead = "trader_teamlead",
  Admin = "admin",
  Support = "support",
  Superadmin = "superadmin",
  Agent = "merchant_agent",
  Platform = "platform",
}

export const adminDealConfig: Config<AdminUser> = [
  {
    label: "ID",
    source: "id",
    renderComponent: (item) => (
      <EllipsisText text={item} copy startLength={8} endLength={8} />
    ),
  },
  {
    label: "Email",
    source: "email",
    renderComponent: (item) => (
      <EllipsisText text={item} copy startLength={14} endLength={14} />
    ),
  },
  {
    label: "Статус",
    source: "status",
  },
  {
    label: "Роль",
    source: "roles",
    renderComponent: (data) => {
      return (
        <>
          {data?.map((role: string, index) => (
            <span key={index}>{role}&nbsp;</span>
          ))}
        </>
      );
    },
  },
  {
    label: "",
    source: "id",
    renderComponent() {
      return <div>Настроить</div>;
    },
  },
];

export const UsersPage = () => {
  const { control, handleSubmit } = useForm<AdminUsersRequest>();
  const { page, limit, setPage, setLimit } = usePagination(100);
  const { setParams } = useUrlFilters();

  const navigate = useNavigate();

  const onUserClick = (item: AdminUser) => {
    navigate(`users/${item.id}`);
  };
  const options = [
    { text: "Активен", value: "active" },
    { text: "Заморожен", value: "frozen" },
    { text: "Заблокирован", value: "blocked" },
    { text: "Не активен", value: "inactive" },
    { text: "Отказ в активации", value: "rejected" },
  ];

  const { state, getAdminUsers, getAdminUserRoles } = useAdminUsers();
  const [rolesOptions, setRolesOption] = useState<SelectOption[]>([]);

  useEffect(() => {
    const status = getFilterParamFromQuery("status");
    const role = getFilterParamFromQuery("role");
    getAdminUsers({ status, role, limit, page });
  }, [getAdminUsers, limit, page]);

  useEffect(() => {
    getAdminUserRoles();
  }, [getAdminUserRoles]);

  useEffect(() => {
    setRolesOption(
      state.roles.map((role) => ({ text: role.name, value: role.id }))
    );
  }, [state.roles]);

  const submit = (data: AdminUsersRequest) => {
    setParams(data);
    getAdminUsers({ ...data, limit: 100, page: 1 });
    setLimit(100);
  };

  return (
    <Block>
      <form className={styles.filter} onSubmit={handleSubmit(submit)}>
        <Input
          name="user_id"
          control={control}
          placeholder="ID"
          clearable
        ></Input>
        <Input
          name="email"
          control={control}
          placeholder="Email"
          clearable
        ></Input>
        <CustomSelect
          name="status"
          control={control}
          options={options}
          placeholder="Статус"
          styles={{ width: "150px" }}
          clearable
        ></CustomSelect>
        <CustomSelect
          name="role"
          control={control}
          options={rolesOptions}
          placeholder="Роль"
          styles={{ width: "150px" }}
          clearable
        ></CustomSelect>
        <Button className={styles.btn}>Search</Button>
      </form>
      <Table
        config={adminDealConfig}
        data={state.users}
        loading={state.loading}
        onRowClick={onUserClick}
        setPage={setPage}
        setLimit={setLimit}
        page={page}
        limit={limit}
        limits={[100, 200, 300]}
        totalCount={state.count}
      ></Table>
    </Block>
  );
};
